




















import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getAccountBalance } from './../service/index';
import { formatNumberByLangCodeUtil } from './../pages/dashboard/perf/utils/index';
@Component({
  name: 'Balance',
})
export default class Balance extends Vue {
  @Getter('account/currency') currency: string;

  cash = '0.0';
  tax = '';
  showTaxType = false;

  created() {
    this.initBalance();
  }

  activated() {
    this.initBalance();
  }

  async initBalance() {
    const { data } = await getAccountBalance();
    this.cash = formatNumberByLangCodeUtil(data.account_balance);
    this.tax = formatNumberByLangCodeUtil(data.tax);
    this.showTaxType = data.show_tax_type === 1;
  }
}
